import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Icon } from 'next/components/ui';
import GuideStep from 'components/InstallationGuide/GuideStep';
import GuideParagraph from 'components/InstallationGuide/GuideParagraph';
import { updateAccountMeta } from 'actions/account/meta';
import { selectAccountFramework } from 'reducers/account/meta';
import { titleCase } from 'utils/';
import { frameworkIconClassNames } from 'constants/installation/snippets';

const row1 = Object.keys(frameworkIconClassNames).slice(0, 4);
const row2 = Object.keys(frameworkIconClassNames).slice(4, 8);

const getFrameworkName = key => {
  switch (key) {
    case 'HTML':
      return 'HTML (Other)';
    case 'PHP':
      return 'PHP';
    default:
      return titleCase(key);
  }
};

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 75px;
  width: 100%;
  margin-top: 20px;
`;

const Section = styled.div`
  display: flex;
  justify-content: space-between;
  width: 64%;
  align-items: left;
  font-weight: 600;
  line-height: 26px;
  font-size: 16px;
  margin-bottom: -16px;
`;

const FrameworkOption = styled.div`
  width: 23%;
  height: 95%;
  display: block;
  cursor: pointer;
  justify-content: left;
  align-items: left;
  border: ${props =>
    props.selected ? '0' : `2px solid ${props.theme['$gray-2']}`};
  color: ${props =>
    props.selected ? props.theme['$gray-0'] : props.theme['$gray-5']};
  box-sizing: border-box;
  border-radius: 6px;
  line-height: 26px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${props =>
    props.selected ? props.theme.$purple : props.theme['$gray-0']};

  i {
    color: ${props => (props.selected ? props.theme['$gray-0'] : 'inherit')};
  }

  &:hover {
    border: ${props =>
      props.selected ? '0' : `2px solid ${props.theme['$gray-5']}`};
    color: ${props =>
      props.selected ? props.theme['$gray-0'] : props.theme['$gray-8']};
    i {
      color: ${props =>
        props.selected ? props.theme['$gray-0'] : props.theme['$gray-7']};
    }
  }
`;

const FrameworkContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 24px;
`;

const FrameworkName = styled.div`
  width: 100%;
`;

const FrameworkIcon = styled(Icon)`
  margin-right: 16px;
  font-size: 32px;
`;

export function InstallFramework({
  accountFramework,
  moveBackward,
  moveForward,
  stepIndex,
  stepMax,
  onSelect,
}) {
  const handleClick = e => {
    onSelect({
      selectedInstallFramework: e.currentTarget.dataset.name,
    });
  };

  const rowElements = row =>
    row.map(frameworkName => {
      return (
        <FrameworkOption
          key={frameworkName}
          data-name={frameworkName}
          selected={accountFramework === frameworkName}
          onClick={handleClick}
        >
          <FrameworkContainer>
            <FrameworkIcon
              icon={frameworkIconClassNames[frameworkName]}
              title={getFrameworkName(frameworkName)}
            />
            <FrameworkName>{getFrameworkName(frameworkName)}</FrameworkName>
          </FrameworkContainer>
        </FrameworkOption>
      );
    });

  return (
    <GuideStep
      stepIndex={stepIndex}
      stepMax={stepMax}
      moveForward={moveForward}
      moveBackward={moveBackward}
      title="Select front-end stack"
    >
      <br />
      <GuideParagraph>
        Installation snippets will be tailored to the stack you choose.
      </GuideParagraph>
      <Section>
        <h4>Single Page Frameworks</h4>
        <h4>Basic Javascript</h4>
      </Section>
      <FlexRow>{rowElements(row1)}</FlexRow>
      <FlexRow>{rowElements(row2)}</FlexRow>
    </GuideStep>
  );
}

function mapStateToProps(state) {
  return {
    accountFramework: selectAccountFramework(state),
  };
}

const mapDispatchToProps = {
  onSelect: updateAccountMeta,
};

export default connect(mapStateToProps, mapDispatchToProps)(InstallFramework);
